import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CatalogMetadata } from '../types';

interface CatalogState {
  catalogs: CatalogMetadata[];
  upsertCatalog: (catalog: CatalogMetadata) => void;
  deleteCatalog: (slug: string) => void;
  updateCatalog: (slug: string, patch: Partial<CatalogMetadata>) => void;
}

function stripHeavyData(catalog: CatalogMetadata): CatalogMetadata {
  return {
    ...catalog,
    sourcePdfDataUrl: undefined,
    pages: catalog.pages.map((page) => ({
      ...page,
      previewUrl: page.previewUrl.startsWith('data:') ? '' : page.previewUrl,
      fullUrl: page.fullUrl.startsWith('data:') ? '' : page.fullUrl
    })),
    qrPng: catalog.qrPng?.startsWith('data:') ? undefined : catalog.qrPng,
    qrSvg: catalog.qrSvg?.startsWith('<svg') ? undefined : catalog.qrSvg
  };
}

export const useCatalogStore = create<CatalogState>()(
  persist(
    (set) => ({
      catalogs: [],
      upsertCatalog: (catalog) =>
        set((state) => {
          const existing = state.catalogs.findIndex((item) => item.slug === catalog.slug);
          if (existing === -1) {
            return { catalogs: [catalog, ...state.catalogs] };
          }
          const next = [...state.catalogs];
          next[existing] = catalog;
          return { catalogs: next };
        }),
      deleteCatalog: (slug) =>
        set((state) => ({ catalogs: state.catalogs.filter((item) => item.slug !== slug) })),
      updateCatalog: (slug, patch) =>
        set((state) => ({
          catalogs: state.catalogs.map((item) =>
            item.slug === slug ? { ...item, ...patch, updated: new Date().toISOString() } : item
          )
        }))
    }),
    {
      name: 'cataloghi-platform-catalogs',
      version: 2,
      partialize: (state) => ({
        catalogs: state.catalogs.map(stripHeavyData)
      })
    }
  )
);
